import * as types from "../../constants/action-types";

export function setTranslations(payload) {
    return {type: types.SET_TRANSLATIONS, payload};
}

export function setWebMode(payload) {
    return {type: types.SET_WEB_MODE, payload};
}

export function setAbout(payload) {
    return {type: types.SET_ABOUT, payload};
}

export function setMediaUrl(payload) {
    return {type: types.SET_MEDIA_URL, payload};
}

export function setRecommendations(payload) {
    return {type:types.SET_RECOMMENDATIONS, payload};
}

export function setPeepsScors(payload) {
    return {type:types.SET_PEEPS_SCORE, payload};
}

export function setDate(payload) {
    return {type: types.SET_DATE, payload};
}

export function setEasySearch(payload) {
    return {type: types.SET_EASY_SEARCH, payload};
}

export function setFlowInformation(payload) {
    return {type:types.SET_FLOW_INFORMATION, payload};
}

export function setLeasingCompanies(payload) {
    return {type:types.SET_LEASING_COMPANIES, payload};
}

export function setEasyBuy(payload) {
    return {type:types.SET_EASY_BUY, payload};
}

export function setFooterItem(payload) {
    return {type:types.SET_FOOTER_ITEM, payload};
}

export function setMenu(payload) {
    return {type:types.SET_MENU, payload};
}

export function setCarCategories(payload) {
    return {type:types.SET_CAR_CATEGORIES, payload};
}

export function setPriceStairs(payload) {
    return {type:types.SET_PRICE_STAIRS, payload};
}

export function setSortTypes(payload) {
    return {type:types.SET_SORT_TYPES, payload};
}

export function setCarsBanners(payload) {
    return {type:types.SET_CAR_BANNERS, payload};
}

export function setAboutPage(payload) {
    return {type:types.SET_ABOUT_PAGE, payload};
}

export function setHowItWork(payload) {
    return {type: types.SET_HOW_DOES_IT_WORK, payload};
}

export function setRoutTable(payload){
    return {type: types.SET_ROUTES_TABLE, payload};
}

export function setFaq(payload) {
    return {type: types.SET_FAQ, payload};
}

export function setCities(payload) {
    return{type:types.SET_CITIES, payload};
}

export function setPrepay(payload) {
    return{type:types.SET_PREPAY, payload};
}